import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Switch } from 'antd';
import classNames from 'classnames';
// import '@style/components/switchBtn.scss';
import '../styles/components/switchBtn.scss';
function SwitchBtn({ onClick, className, size = 'small', ...restProps }) {
  const handleClick = (e) => {
    onClick && onClick(e);
  };
  const classes = classNames('switch-btn', className, {
    'switch-btn-small': size === 'small',
  });
  return (
    <Switch
      size={size}
      className={classes}
      onClick={handleClick}
      {...restProps}
    />
  );
}

SwitchBtn.defaultProps = {
  onClick: null,
};

SwitchBtn.propTypes = { onClick: PropTypes.func };

export default memo(SwitchBtn);
